import "./ContactSection.css";
import SectionTitle from "../common/SectionTitle";

const ContactSection = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-wrapper">
        <SectionTitle title="kontakt" />
        <h2 className="contact-subtitle">Ozvěte se nám</h2>

        <div className="contact-content">
          <div className="contact-column">
            <span className="contact-label">Jednatel</span>
            <p className="contact-name">Ing. Petr Sedlák</p>
            <a href="tel:+420605967051" className="contact-phone">
              +420 605 967 051
            </a>
            <a href="mailto:sedlak@sestavhb.cz" className="contact-email">
              sedlak@sestavhb.cz
            </a>
          </div>

          <div className="contact-column contact-column--company">
            <div className="contact-block">
              <span className="contact-label">Sídlo</span>
              <p className="contact-value">SESTAV HB s.r.o.</p>
              <p className="contact-value">Nad Žabincem 767</p>
              <p className="contact-value">580 01 Havlíčkův Brod</p>
            </div>

            <div className="contact-block contact-block--divider">
              <span className="contact-label">Identifikace</span>
              <p className="contact-value">IČO: 19570791</p>
              <p className="contact-value">DIČ: CZ19570791</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;